import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { auth } from "../firebase";

class UserSidebar extends Component {
  state = {};

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({ [menuState]: false });
    } else if (Object.keys(this.state).length === 0) {
      this.setState({ [menuState]: true });
    } else {
      Object.keys(this.state).forEach((i) => {
        this.setState({ [i]: false });
      });
      this.setState({ [menuState]: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    document.querySelector("#sidebar").classList.remove("active");
    Object.keys(this.state).forEach((i) => {
      this.setState({ [i]: false });
    });

    const dropdownPaths = [
      { path: "/apps", state: "appsMenuOpen" },
      { path: "/basic-ui", state: "basicUiMenuOpen" },
      { path: "/form-elements", state: "formElementsMenuOpen" },
      { path: "/tables", state: "tablesMenuOpen" },
      { path: "/icons", state: "iconsMenuOpen" },
      { path: "/charts", state: "chartsMenuOpen" },
      { path: "/user-pages", state: "userPagesMenuOpen" },
      { path: "/error-pages", state: "errorPagesMenuOpen" },
    ];

    dropdownPaths.forEach((obj) => {
      if (this.isPathActive(obj.path)) {
        this.setState({ [obj.state]: true });
      }
    });
  }

  logout() {
    auth.signOut();
  }

  render() {
    return (
      <nav
        style={{ minHeight: "100vh" }}
        className="sidebar sidebar-offcanvas"
        id="sidebar"
      >
        <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top border-bottom-gray-100">
          <Link className="sidebar-brand brand-logo" to="/dashboard">
            <img
              src={require("../assets/images/LogoRectangle.png")}
              alt="logo"
              style={{ padding: '4px' }}
            />
          </Link>
          <Link className="sidebar-brand brand-logo-mini" to="/dashboard">
            <img
              src={require("../assets/images/LogoRectangle.png")}
              alt="logo"
            />
          </Link>
        </div>

        <ul className="nav">
         

          <li className="nav-item nav-category px-4 mb-2">
            <span className="nav-link text-uppercase font-weight-700 text-muted" style={{ fontSize: '0.65rem', letterSpacing: '1px' }}>Management</span>
          </li>

          {[
            { path: "/dashboard", title: "Dashboard", icon: "mdi-view-dashboard-outline" },
            { path: "/profile", title: "Profile", icon: "mdi-account-outline" },
            { path: "/subscription", title: "Subscription", icon: "mdi-credit-card-settings-outline" },
            { path: "/invoices", title: "Invoices", icon: "mdi-file-document-outline" },
            { path: "/status", title: "App Status", icon: "mdi-television-guide" },
            { path: "/settings", title: "Settings", icon: "mdi-settings" },
            { path: "/cardDetails", title: "Update Card", icon: "mdi-credit-card" },
          ].map((item) => (
            <li
              key={item.path}
              className={
                this.isPathActive(item.path)
                  ? "nav-item menu-items active"
                  : "nav-item menu-items"
              }
            >
              <Link className="nav-link" to={item.path}>
                <span className={`menu-icon ${this.isPathActive(item.path) ? 'text-primary' : ''}`}>
                  <i className={`mdi ${item.icon}`}></i>
                </span>
                <span className="menu-title">{item.title}</span>
              </Link>
            </li>
          ))}

          <li className="nav-item nav-category px-4 mt-4 mb-2">
            <span className="nav-link text-uppercase font-weight-700 text-muted" style={{ fontSize: '0.65rem', letterSpacing: '1px' }}>Account Control</span>
          </li>

          <li className="nav-item menu-items logout-item mt-2">
            <a href="/" onClick={(e) => { e.preventDefault(); this.logout(); }} className="nav-link">
              <span className="menu-icon">
                <i className="mdi mdi-power text-danger"></i>
              </span>
              <span className="menu-title text-danger font-weight-700">Log Out</span>
            </a>
          </li>
        </ul>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {
    this.onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector("body");
    document.querySelectorAll(".sidebar .nav-item").forEach((el) => {
      el.addEventListener("mouseover", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      });
      el.addEventListener("mouseout", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      });
    });
  }
}

export default withRouter(UserSidebar);
